(() => {
  const initializeGallery = (gallery) => {
    if (gallery.dataset.thdGalleryReady === 'true') return;

    const track = gallery.querySelector('[data-thd-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-thd-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-thd-gallery-thumbnail]'));
    const thumbnailStrip = gallery.querySelector('[data-thd-gallery-thumbnails]');
    const counter = gallery.querySelector('[data-thd-gallery-counter]');
    const previous = gallery.querySelector('[data-thd-gallery-previous]');
    const next = gallery.querySelector('[data-thd-gallery-next]');
    if (!track || slides.length === 0) return;

    let activeIndex = 0;
    let touchStartX = 0;
    let touchStartY = 0;

    const show = (requestedIndex) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
      slides.forEach((slide, index) => {
        const inactive = index !== activeIndex;
        slide.setAttribute('aria-hidden', String(inactive));
        slide.toggleAttribute('inert', inactive);
        if (inactive) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbnails.forEach((thumbnail, index) => {
        if (index === activeIndex) {
          thumbnail.setAttribute('aria-current', 'true');
          if (thumbnailStrip) {
            const left = thumbnail.offsetLeft;
            const right = left + thumbnail.offsetWidth;
            const visibleLeft = thumbnailStrip.scrollLeft;
            const visibleRight = visibleLeft + thumbnailStrip.clientWidth;
            let targetLeft = visibleLeft;
            if (left < visibleLeft) targetLeft = left;
            else if (right > visibleRight) targetLeft = right - thumbnailStrip.clientWidth;
            if (targetLeft !== visibleLeft) {
              const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              thumbnailStrip.scrollTo({ left: targetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
            }
          }
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
    };

    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => show(Number(thumbnail.dataset.thdGalleryIndex))));
    gallery.addEventListener('keydown', (event) => {
      if (event.target !== gallery) return;
      if (event.key === 'ArrowLeft') show(activeIndex - 1);
      else if (event.key === 'ArrowRight') show(activeIndex + 1);
      else if (event.key === 'Home') show(0);
      else if (event.key === 'End') show(slides.length - 1);
      else return;
      event.preventDefault();
    });
    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      show(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });
    gallery.addEventListener('thd:show-slide', (event) => show(event.detail.index));
    gallery.dataset.thdGalleryReady = 'true';
    show(0);
  };

  const initializeAll = (root = document) => root.querySelectorAll('[data-thd-gallery]').forEach(initializeGallery);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = document.querySelector(`[data-thd-gallery-block="${event.detail.blockId}"]`);
    if (!slide) return;
    const gallery = slide.closest('[data-thd-gallery]');
    const slides = Array.from(gallery.querySelectorAll('[data-thd-gallery-slide]'));
    gallery.dispatchEvent(new CustomEvent('thd:show-slide', { detail: { index: slides.indexOf(slide) } }));
  });
})();
